import ManaCurveV2 from 'components/deckPage/charts/ManaCurveV2'
import QuantitiyTables from 'components/deckPage/charts/QuantityTables'
import ColorBarChart from 'components/deckPage/charts/ColorBarChart'

import { useAppSelector } from 'app-redux/hooks'

import { getDeckPriceAndInfo } from 'utils/calculateDeckPrice'
import { getPriceStringFromFloat } from 'utils/Price'

import styles from './legacyStats.module.scss'

const LegacyStats = () => {
  const cardMap = useAppSelector(state => state.deck.cardMap)
  const categories = useAppSelector(state => state.deck.categories)
  const priceSource = useAppSelector(state => state.active.priceSource)

  const { deckSize, estDeckCost, costWithoutBasics, excludingExactOwned, excludingAnyOwned } = getDeckPriceAndInfo(
    Object.values(cardMap),
    categories,
    priceSource,
  )

  const deck = Object.values(cardMap).filter(card => {
    const primaryCategoryName = card.categories[0]
    const category = categories[primaryCategoryName]

    if (primaryCategoryName === 'Sideboard' || !category?.includedInDeck) return false

    return true
  })

  return (
    <div>
      <div className={styles.deckInfo}>
        <h4>Deck Info</h4>
        <div className={styles.infoContent}>
          <label>Deck size: {deckSize}</label>
          <label>Est cost: {getPriceStringFromFloat(estDeckCost, priceSource[0])}</label>
        </div>
      </div>
      <ColorBarChart />
      <ManaCurveV2 cards={deck} showAverageManaValue showTotalManaValue className={styles.manaCurve} />
      <QuantitiyTables />
    </div>
  )
}

export default LegacyStats
